import { Affix as AntdAffix } from 'antd';
import { AffixProps as AntdAffixProps } from 'antd/lib/affix';

export type AffixProps = AntdAffixProps;

export const Affix = AntdAffix;

export default Affix;
